export default __webpack_public_path__ + "static/media/menu-meteor-3.ac13e118.png";